import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as cashFlowActions from './../../../../../../actions/cashFlowAction';
import CashFlowDetail from './CashFlowDetail';

const mapStateToProps = state => {
    return {
        CashFlowState: state.cashFlowReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransactions: (filters) => dispatch(cashFlowActions.getTransactions(filters)),
        getAccounts: (filters) => dispatch(cashFlowActions.getAccounts(filters)),
        getTransactionsImbalance: (filters) => dispatch(cashFlowActions.getTransactionsImbalance(filters)),
        createReceiptPayslipDetail: (receiptsPayslip) => dispatch(cashFlowActions.createReceiptPayslipDetail(receiptsPayslip))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CashFlowDetail));
